import React, { useEffect, useState } from "react";
import styles from "./statistics-overview.module.css";
import StatisticsCard from "../../../../components/statistics-card/statistics-card";
import { getInstitutionOverviewStatistics } from "../../../../services/institution";

const StatisticsOverview = () => { 
  const [overviewStatistics, setOverviewStatistics] = useState({})

  const fetchSchoolStatistics = async () => { 
    try { 
      const response = await getInstitutionOverviewStatistics()

      if(response.status) {
        setOverviewStatistics(response?.data?.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchSchoolStatistics()
  }, []) 

  const overview_statistics = [
    {
      icon_name: "graduation-hat-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Active Students",
      card_bg_color: "rgba(255, 243, 238, 1)",
      icon_container_bg_color: "rgba(224, 90, 33, 1)",
      statistic_value: overviewStatistics?.total_active_students ?? "-",
    },
    {
      icon_name: "male",
      icon_fill: "transparent",
      icon_stroke: "transparent",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Male Students",
      card_bg_color: "rgba(233, 243, 255, 1)",
      icon_container_bg_color: "rgba(86, 155, 246, 1)",
      statistic_value: overviewStatistics?.total_male_students ?? "-",
    },
    {
      icon_name: "female",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Female Students",
      card_bg_color: "rgba(245, 240, 255, 1)",
      icon_container_bg_color: "rgba(127, 86, 217, 1)",
      statistic_value: overviewStatistics?.total_female_students ?? "-",
    },
    {
      icon_name: "users-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Active Teachers",
      card_bg_color: "rgba(255, 251, 233, 1)",
      icon_container_bg_color: "rgba(235, 206, 61, 1)",
      statistic_value: overviewStatistics?.total_active_teachers ?? "-",
    },
    {
      icon_name: "book-closed",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Subjects",
      card_bg_color: "rgba(242, 255, 244, 1)",
      icon_container_bg_color: "rgba(41, 194, 65, 1)",
      statistic_value: overviewStatistics?.total_subjects ?? "-",
    },
    {
      icon_name: "clipboard",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Classes",
      card_bg_color: "rgba(231, 248, 255, 1)",
      icon_container_bg_color: "rgba(75, 202, 255, 1)",
      statistic_value: overviewStatistics?.total_classes ?? "-",
    },
  ];

  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={statistic_value}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default StatisticsOverview;
